import React from 'react';
import {Grid, Input, Dropdown, Label} from 'semantic-ui-react';
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import debounce from "lodash.debounce";
import {ChartColors} from "../../components/charts/constants/chart-color-constants";

export default class ClosingPriceFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            commodity: "",
            fromDate: "",
            toDate: "",
            periods: []
        };

        this.maxPeriods = Object.values(ChartColors).length;
    }

    generateOptionsFor = (data) => {
        return data.map((x, index) => {return { key: index, value: x, text: x}});
    };

    onChangeCommodity = (event, data) => {
        this.setState({commodity: data.value}, this.raiseChange);
    };

    onChangePeriod = (event, data) => {
        if(data.length > this.maxPeriods) { return; }
        this.setState({periods: data.value}, this.raiseChange);
    };

    fromDateChanged = (newDate) => {
        this.setState({ fromDate: newDate }, this.raiseChange);
    }

    toDateChanged = (newDate) => {
        this.setState({ toDate: newDate }, this.raiseChange);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    raiseChange = debounce(() => {
        this.props.onFilterUpdated(this.state);
    }, 1000);


    render() {
        const commodityOptions = this.generateOptionsFor(this.props.commodities);
        const periodOptions = this.generateOptionsFor(this.props.periods);
        const CustomInput = ({ value, onClick }) => (
            <Input value={value} onClick={onClick} icon="calendar"/>
        );

        return (
            <Grid padded stackable columns='equal'>
                <Grid.Row>
                    <Grid.Column>
                        <label>Commodity</label>
                        <Dropdown
                            placeholder='Commodity'
                            fluid
                            selection
                            search
                            options={commodityOptions}
                            disabled={this.props.disabled}
                            onChange={this.onChangeCommodity}
                        />
                        {this.state.commodity.length === 0 &&
                        <Label basic color='red' pointing>
                            Please select a commodity
                        </Label>}
                    </Grid.Column>
                    <Grid.Column width={10}>
                        <label>Periods</label>
                        <Dropdown
                            placeholder='Period'
                            fluid
                            selection
                            multiple
                            options={periodOptions}
                            disabled={this.props.disabled}
                            onChange={this.onChangePeriod}
                        />
                        {this.state.periods.length === 0 &&
                        <Label basic color='red' pointing>
                            Please select at least one period
                        </Label>}
                        {this.state.periods.length > this.maxPeriods &&
                        <Label basic color='red' pointing>
                            You can only select a maximum of {this.maxPeriods} periods
                        </Label>}
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <label>From Date</label>
                        <br/>
                        <DatePicker selected={this.state.fromDate} locale="en-GB" dateFormat="dd/MM/yyyy" onChange={this.fromDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}/>
                        {this.state.fromDate == null &&
                        <Label basic color='red' pointing>
                            Please select a starting date range
                        </Label>}
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <label>To Date</label>
                        <br/>
                        <DatePicker selected={this.state.toDate} locale="en-GB" dateFormat="dd/MM/yyyy" onChange={this.toDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}/>
                        {this.state.toDate == null &&
                        <Label basic color='red' pointing>
                            Please select an ending date range
                        </Label>}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

ClosingPriceFilters.propTypes = {
    onFilterUpdated: PropTypes.func.isRequired,
    commodities: PropTypes.array.isRequired,
    periods: PropTypes.array.isRequired,
};